import { elementFieldTypeEnums } from './elementFieldTypes';

const dataFieldTypes = [
  { value: 'name', label: 'Customer name' },
  { value: 'first-name', label: 'Customer first name' },
  { value: 'last-name', label: 'Customer last name' },
  { value: 'email', label: 'Customer email address' },
  { value: 'phone', label: 'Customer phone' },
  { value: 'company-name', label: 'Company name' },
  { value: 'billing-email', label: 'Billing email address' },
  { value: 'address-line1', label: 'Billing address line one' },
  { value: 'address-line2', label: 'Billing address line two' },
  { value: 'address-city', label: 'Billing address city' },
  { value: 'address-state', label: 'Billing address state' },
  { value: 'address-postal_code', label: 'Billing address postal code' },
  { value: 'address-country', label: 'Billing address country' },
  { value: 'shipping-name', label: 'Shipping name' },
  { value: 'shipping-phone', label: 'Shipping phone' },
  { value: 'shipping-address-line1', label: 'Shipping address line one' },
  { value: 'shipping-address-line2', label: 'Shipping address line two' },
  { value: 'shipping-address-city', label: 'Shipping address city' },
  { value: 'shipping-address-state', label: 'Shipping address state' },
  {
    value: 'shipping-address-postal_code',
    label: 'Shipping address postal code',
  },
  { value: 'shipping-address-country', label: 'Shipping address country' },
];

const getDataFieldTypesForElement = element => {
  switch (element) {
    case elementFieldTypeEnums.CHECKBOX:
    case elementFieldTypeEnums.QUANTITY:
    case elementFieldTypeEnums.TAX_ID:
    case elementFieldTypeEnums.PO_NUMBER:
    case elementFieldTypeEnums.MULTIPLE_CHOICE:
    case elementFieldTypeEnums.MULTI_SELECT:
    case elementFieldTypeEnums.DATE_TIME:
    case elementFieldTypeEnums.DATE:
    case elementFieldTypeEnums.TIME:
    case elementFieldTypeEnums.TEXTAREA:
      return null;
    case elementFieldTypeEnums.ADDRESS:
      return [];
    case elementFieldTypeEnums.EMAIL:
      return [
        dataFieldTypes.find(type => type.value === 'email'),
        dataFieldTypes.find(type => type.value === 'billing-email'),
      ];
    case elementFieldTypeEnums.COUNTRY:
      return dataFieldTypes.filter(
        type => type.value === 'address-country' || type.value === 'shipping-address-country',
      );
    case elementFieldTypeEnums.PHONE:
      return dataFieldTypes.filter(
        type => type.value === 'phone' || type.value === 'shipping-phone',
      );
    default:
      return dataFieldTypes;
  }
};

const getDataFieldTypeLabel = type => {
  const fieldType = dataFieldTypes.find(fieldType => fieldType.value === type);

  return fieldType ? fieldType.label : '';
};

export { getDataFieldTypeLabel, dataFieldTypes, getDataFieldTypesForElement };
